// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import experiments from '@reverbdotcom/commons/src/experiments';
import { displayPaymentMethod } from '../lib/payment_method_icons';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import { ListingPaymentOptionsFields } from '@reverbdotcom/commons/src/gql/graphql';

type Listing = ListingPaymentOptionsFields.Fragment;

interface Props {
  listing: Listing;
}

const componentName = 'ListingPaymentOptions';

export function ListingPaymentOptions(props: Props) {
  const { listing } = props;

  const showPaymentMethods = useExpEnabled(experiments.ACCEPTED_PAYMENT_METHODS);
  const acceptedPaymentMethods = listing?.acceptedPaymentMethods || [];

  useViewTracking({
    eventName: MParticleEventName.ViewedListingAcceptedPaymentMethods,
    componentName,
    listingId: listing.id,
    paymentMethodsAvailable: acceptedPaymentMethods.slice(0).sort().join('|'),
  }, showPaymentMethods);

  if (!showPaymentMethods) return null;

  return (
    <div className="item2__sidebar-module">
      <div className="item2__sidebar-module__header">
        {I18n.t('discovery.paymentOptions.accepts')}
      </div>
      <div
        className="d-flex fx-wrap"
        style={{ margin: '0 -0.5rem -0.5rem' }}
      >
        {acceptedPaymentMethods.map(paymentMethod => {
          const display = displayPaymentMethod(paymentMethod);
          if (!display) return null;
          return display.icons.map(cardIcon => {
            return (
              <div key={`${cardIcon.description}`} className="mlr-1 mb-1">
                <img
                  style={{ width: '4rem' }}
                  src={cardIcon.url}
                  alt={cardIcon.description}
                />
              </div>
            );
          });
        })}
      </div>
    </div>
  );
}

export const ListingPaymentOptionsFragment = gql`
  fragment ListingPaymentOptionsFields on Listing {
    _id
    id
    acceptedPaymentMethods
  }
`;
